import { logosTiles } from "@resourcehub/resourcehub-assets";

export default ({ strings }) => [
    {
        image: {
            alt: strings.awards_twitter,
            asset_static: logosTiles.logosTilesTwitterSvg
        }
    },
    {
        image: {
            alt: strings.awards_bmw,
            asset_static: logosTiles.logosTilesBmwSvg
        }
    },
    {
        image: {
            alt: strings.awards_uber,
            asset_static: logosTiles.logosTilesUberSvg
        }
    },
    {
        image: {
            alt: strings.awards_ikea,
            asset_static: logosTiles.logosTilesIkeaSvg
        }
    },
    {
        image: {
            alt: strings.awards_williams_sonoma,
            asset_static: logosTiles.logosTilesWsSvg
        }
    },
    {
        image: {
            alt: strings.awards_lego,
            asset_static: logosTiles.logosTilesLegoSvg
        }
    }
];
